import { createApp } from 'vue'
import App from './App.vue'
import BootstrapVueNext from 'bootstrap-vue-next'
import vClickOutside from "click-outside-vue3"
import i18n from './i18n'
import store from './state/store'
import router from "./router"
import Auth from './state/auth'
import Button from './common/button'

import '@/assets/scss/main.scss'
import '@/assets/scss/normalize.scss'
import 'bootstrap/dist/js/bootstrap.bundle';
import 'remixicon/fonts/remixicon.css';

import Numbers from './common/number';

//const BASE_URL = 'https://pphback.metacoresystemsinc.com/api';
const LOCAL_URL = 'http://localhost:8000/api';

const app = createApp(App);

app.config.globalProperties.$baseURL = LOCAL_URL;

app.mixin(Button)
app.use(router);
app.use(BootstrapVueNext)
app.mixin(Auth)
app.mixin(Numbers)
app.use(i18n)
app.use(store)
app.use(vClickOutside)
app.mount("#app");